module.exports = __webpack_public_path__ + "static/victor-hartwell-3ac0096a9f2f77c95646f7b5c33e9e4e.png";